export default __webpack_public_path__ + "static/hadawa_video-b55c1dc27871ba2dcb4a119c63b97b76.webm";